import { 
    IMutations,
    IMutationsGrantPayload
} from './mutations.types'
import { IGrant, INotification, IGrantData } from '@/entities'
import { AppConstants as _app } from '@/shared/app.constants'

export const mutations: IMutations = {
    
    /** refresh the state with application header info */
    setGrant(state: IGrantData, payload: IMutationsGrantPayload): void {
        if(!payload.grant.WorkflowInfo) {
            payload.grant.WorkflowInfo = state.selectedGrant.WorkflowInfo
        }        
        state.selectedGrant = payload.grant;
    },
    
    setPPO(state: IGrantData, payload: IMutationsGrantPayload): void {
        state.selectedGrant.PrimaryProgramOfficerId = payload.grant.PrimaryProgramOfficerId;
    },

    /** set the grant data */
    setGrantData(state: IGrantData, payload: any): void {
        state.grantData = payload;
    },    
    /** set the validation messages */
    setValidationMessages(state: IGrantData, payload: any): void {
        if(payload && payload.length > 0) {
            state.showValidationDilog = true;
            state.validationMessages = payload;
        }   
    }

}
